export default "__VITE_ASSET__715973e8__"